import apiClient from '../apiClient';
import { GET_RESTAURANT_CATEGORY_URL } from '../apiUrl';

const getRestaurantCategoryApi = () => {
  return apiClient.get(GET_RESTAURANT_CATEGORY_URL);
};

export default getRestaurantCategoryApi;
